export default {
  label: {
    size: {
      width: '宽度',
      height: '高度'
    }
  },
  form: {
    title: '标题',
    titlePlaceholder: '请输入标题',
    subtitle: '副标题',
    subtitlePlaceholder: '请输入副标题',
    content: '内容',
    clickToJump: '超链接',
    internalPageOption: '内部页面',
    externalPageOption: '外部页面',
    externalPagePlaceholder: '请输入地址',
    openInNewWindow: '在新窗口打开',
    upload: '上传',
    yes: '是',
    no: '否',
    img: '图片',
    video: '视频',
    notSupportVideo: '您的浏览器不支持 HTML5 video 标签。',
    uploadCanNotEmpty: '请上传一张图片或一段视频',
    linkCanNotEmpty: '请选择一个内部组件或填写一个外部链接',
    align: '对齐'
  },
  message: {
    saveSuccess: '保存成功',
    failedSave: '保存失败'
  },
  SIZE_TYPE: {
    AUTO: '自动',
    FIXED: '固定值',
    SCREEN_PERCENTAGE: '屏幕百分比'
  }
}
